import Image from 'next/image';

import { CompanyType } from '_data/index';

type Props = {
  companies?: CompanyType[];
};

export const CompanyLogos = (props: Props) => {
  const { companies } = props;

  return (
    <div className="logo-wrapper layout-row layout-align-center-center layout-wrap gap-8">
      {companies?.map((company: CompanyType) => (
        <div
          className="layout-row layout-align-center-center relative"
          key={company.id}
          style={{ maxWidth: 112, maxHeight: 80 }}>
          <Image
            loading="eager"
            className="logo company-logo"
            alt={company.name}
            src={company.logoSrc as string}
            width={80}
            height={32}
            sizes="100vw"
            key={company.id}
            style={{ objectFit: 'contain' }}
          />
        </div>
      ))}
    </div>
  );
};
